import React from 'react';
import Modal from './Modal.js';
import Text from '../Text.js';
import DateInput from '../../components/TextFields/DateInput.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';

/**
 * 
 * @returns 
 */
const EffectiveDateModal = ({
  open,
  onClick,
  onClose,
  handleInputChange,
  loader,
  effectiveDate,
  effectiveDateError
}) => /*#__PURE__*/React.createElement(Modal, {
  open: open,
  onClose: onClose,
  title: i18n.t(tokens.titles.setEffectiveDate),
  primaryButton: {
    label: "Submit",
    onClick: onClick
  },
  loader: loader
}, /*#__PURE__*/React.createElement(Text, {
  medium: true
}, i18n.t(tokens.labels.pleaseProvideEffectiveDate)), /*#__PURE__*/React.createElement(DateInput, {
  label: i18n.t(tokens.labels.effectiveDate),
  value: effectiveDate,
  onChange: e => handleInputChange('effectiveDate', e.target.value),
  error: Boolean(effectiveDateError),
  helperText: effectiveDateError,
  fullWidth: true,
  required: true
}), /*#__PURE__*/React.createElement(Text, {
  medium: true,
  margin: "10px 0 0 0"
}, i18n.t(tokens.labels.changesAppliedOnEffectiveDate)));
export default EffectiveDateModal;